interface PEConifg {
  [key: string]: string;
}
export const PE_CONFIG: PEConifg = {
  publicKey: 'pk_test_9AoQEvq7qc9vpqbcV1WrCLefS9WF1Uns', // "CHANGE ME",
  scriptURL: 'https://console.payengine.dev/js/1.0.0/embed.js',
};
